import gql from 'graphql-tag';

export const allowMOCEventCategoryDelete = gql`
  query allowMOCEventCategoryDelete($id: ID!) {
    allowMOCEventCategoryDelete(id: $id) {
      value
    }
  }
`;
